import React from 'react';
import * as Styled from './styled';

interface HtmlTextProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: string;
}

const HtmlText: React.FC<HtmlTextProps> = ({ children, ...props }) =>
  children ? <Styled.CssWrapper {...props} dangerouslySetInnerHTML={{ __html: children }} /> : null;

export default HtmlText;
